import { render, staticRenderFns } from "./PassengerCard.vue?vue&type=template&id=881cfa56&scoped=true&"
import script from "./PassengerCard.vue?vue&type=script&lang=js&"
export * from "./PassengerCard.vue?vue&type=script&lang=js&"
import style0 from "./PassengerCard.vue?vue&type=style&index=0&id=881cfa56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881cfa56",
  null
  
)

export default component.exports